module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_1_2_4.72e52755.png";